import { render, staticRenderFns } from "./Breeds.vue?vue&type=template&id=e94317e4&scoped=true&"
import script from "./Breeds.vue?vue&type=script&lang=js&"
export * from "./Breeds.vue?vue&type=script&lang=js&"
import style0 from "./Breeds.vue?vue&type=style&index=0&id=e94317e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94317e4",
  null
  
)

export default component.exports